import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import PriceTable from "./pages/PriceTable";
import PriceChart from "./pages/PriceChart";
import PriceTrends from "./pages/PriceTrends";
import AnalysisPage from "./pages/AnalysisPage";
import ComparePage from "./pages/ComparePage";
import LoginPage from "./pages/LoginPage.jsx";
import RequireAuth from "./components/RequireAuth.jsx";
import RequireRole from "./components/RequireRole.jsx";
import AdminPanel from "./pages/AdminPanel.jsx";
import CompareHelp from "./pages/CompareHelp.jsx";
import PasswordResetPage from "./pages/PasswordResetPage.jsx";
import PasswordResetRequestPage from "./pages/PasswordResetRequestPage.jsx";

export default function App() {
  return (
    <Router>
      <div className="min-h-screen bg-white">
        <Navbar />
        <div className="p-6">
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/forgot-password" element={<PasswordResetRequestPage />} />
            <Route path="/reset-password" element={<PasswordResetPage />} />
            <Route element={<RequireAuth />}>
              <Route path="/" element={<ComparePage />} />
              <Route path="/chart" element={<PriceChart />} />
              <Route path="/trends" element={<PriceTrends />} />
              <Route path="/analysis" element={<AnalysisPage />} />
              <Route path="/corporate" element={<ComparePage />} />
              <Route path="/help/compare" element={<CompareHelp />} />
              <Route element={<RequireRole role="admin" />}>
                <Route path="/prices" element={<PriceTable />} />
                <Route path="/admin" element={<AdminPanel initialTab="users" />} />
                <Route path="/admin/users" element={<AdminPanel initialTab="users" />} />
                <Route
                  path="/admin/data-quality"
                  element={<AdminPanel initialTab="data-quality" />}
                />
                <Route
                  path="/admin/fuel-categories"
                  element={<AdminPanel initialTab="fuel" />}
                />
                <Route
                  path="/admin/scrape-targets"
                  element={<AdminPanel initialTab="targets" />}
                />
                <Route
                  path="/admin/abc-batch"
                  element={<AdminPanel initialTab="abc-batch" />}
                />
                <Route
                  path="/admin/calculation-rules"
                  element={<AdminPanel initialTab="calculation-rules" />}
                />
                <Route
                  path="/admin/db-stats"
                  element={<AdminPanel initialTab="db" />}
                />
                <Route
                  path="/admin/activities"
                  element={<AdminPanel initialTab="activities" />}
                />
              </Route>
            </Route>
          </Routes>
        </div>
      </div>
    </Router>
  );
}
